import {
  requestQueue as sharedRequestQueue,
  requestSignal as sharedRequestSignal,
  undoSignal as sharedUndoSignal
} from "components/supplier_admin/shared/queue_polling";

const requestAssemblyQueue = state =>
  sharedRequestQueue("/supplier/assembly_queue", state, "Assembly queue request failed.");

const requestSignal = ({ shipmentId, signalType }) =>
  sharedRequestSignal({
    shipmentId,
    signalType,
    errorMessage: "Assembly queue signal request failed."
  });

const undoSignal = ({ shipmentId, signalId }) =>
  sharedUndoSignal({
    shipmentId,
    signalId,
    errorMessage: "Assembly queue undo signal request failed."
  });

export { requestAssemblyQueue, requestSignal, undoSignal };
